import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ViewProgramFooterWrapper = styled.div`
  margin: 32px 0px;
  background-color: ${COLORS.cirrus_white};
  padding: 32px 16px 20px;
  display: flex;
  justify-content: end;
  gap: 16px;

  ${responsive.MOBILE`
    margin-bottom: 0px;
    padding: 24px 8px 16px 8px !important;
    padding-right: 0px;
    justify-content: center;
    flex-direction: column-reverse;
    margin-top:  0px;
  `}
`;
